import {
    Background,
    Controls,
    MiniMap,
    ReactFlow,
    useNodesState,
    useEdgesState,
} from '@xyflow/react'

import { useFlowchartViewModel, nodeTypes } from './FlowchartViewModel'
import { useEffect } from 'react'

import '@xyflow/react/dist/style.css'
import DownloadButton from './DownloadButton'

const ChainFlowchart = ({ chain }) => {
    
    const vm = useFlowchartViewModel()
    
    const [nodes, setNodes, onNodesChange] = useNodesState([])
    const [edges, setEdges, onEdgesChange] = useEdgesState()
    
    useEffect(() => {
        
        const values = vm.calculateNodesAndEdges(chain)
        
        setNodes(values.nodes)
        setEdges(values.edges)
        
    }, [chain])
    
    return (
        <ReactFlow
            className="!text-slate-800"
            nodes={nodes}
            nodeTypes={nodeTypes}
            edgeTypes={{}}
            onNodesChange={onNodesChange}
            edges={edges}
            onEdgesChange={onEdgesChange}
            fitView>
            <Background />
            <MiniMap />
            <Controls />
            <DownloadButton />
        </ReactFlow>
    )
}

export default ChainFlowchart